<template>
    <div class="pt-5">
        <Card>
            <template v-slot:title-panel> Datos de la solicitud </template>

            <div v-if="showActionsComp" class="botones-container">
                <template v-for="boton in botones">
                    <v-btn v-if="boton.show" :key="boton.label" class="stats-button common-botton" dark
                        :loading="loading" @click="boton.action">
                        <v-icon small class="mr-1">{{ boton.icon }}</v-icon>
                        <span>{{ boton.label }}</span>
                    </v-btn>
                </template>
            </div>

            <v-row>
                <v-col cols="3">
                    <v-select v-if="isViewMode && !isCreatingNew" :readonly="true" label="Estatus" :items="statusItems"
                        v-model="solicitudLocal.statusId" item-text="text" item-value="value" outlined dense />
                </v-col>
                <v-col cols="9" v-if="solicitudLocal.motivo_detencion">
                    <v-text-field label="Motivo detencion" v-model="solicitudLocal.motivo_detencion"
                        :value="solicitudLocal.motivo_detencion" outlined color="#b11f1f"
                        :readonly="true"></v-text-field>
                </v-col>
            </v-row>

            <v-form ref="firstStepForm" :lazy-validation="true">
                <v-row>
                    <v-col m="12" md="6" lg="4" xl="4">
                        <v-text-field label="Tipo de servicio" v-model="solicitudLocal.categoria"
                            placeholder="Requerido" outlined color="#b11f1f" :readonly="true"
                            :rules="requiredRule"></v-text-field>
                    </v-col>
                    <v-col m="12" md="6" lg="4" xl="4">
                        <v-select label="Motivo de retención" :items="motivosRetencion"
                            v-model="solicitudLocal.motivoRetencion" placeholder="Requerido" item-text="motivoRetencion"
                            item-value="motivoRetencion" outlined color="#b11f1f" :readonly="isViewMode"
                            :rules="requiredRule"></v-select>
                    </v-col>
                    <v-col cols="12" md="6" lg="4" xl="4">
                        <v-text-field :label="isViewMode ? 'Telefono' : 'Confirmar telefono'"
                            v-model="solicitudLocal.celular" outlined type="number" v-mask="'##########'"
                            :rules="[...requiredRule, $rules.min(10), $rules.max(10)]" color="#b11f1f"
                            :readonly="isViewMode">
                            <template v-slot:append>
                                <v-tooltip top v-if="isTelefonoInListaNegra && isViewMode">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon color="#b11f1f" v-bind="attrs" v-on="on">mdi-phone-off</v-icon>
                                    </template>
                                    <span>Este teléfono está en lista negra</span>
                                </v-tooltip>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" :lg="(isViewMode && polizaSustituida) ? 8 : 6" v-if="esDownsell && productoAnterior">
                        <v-text-field :label="isViewMode ? 'Plan Anterior' : 'Plan Actual'"
                            :value="currentProduct.producto_lead + ' - ' + currentProduct.nombre + ' - $' + currentProduct.subsecuentePago"
                            outlined color="#b11f1f" readonly />
                    </v-col>
                    <v-col cols="12" md="6" lg="4" v-if="esDownsell && isViewMode && polizaSustituida">
                        <v-text-field label="Emisión Anterior" :value="solicitudLocal.emisionId" outlined
                            color="#b11f1f" readonly append-icon="mdi-open-in-new"
                            @click:append="abrirEmision(solicitudLocal.emisionId)" />
                    </v-col>

                    <v-col cols="12" md="6" :lg="(isViewMode && polizaSustituida) ? 8 : 6" v-if="esDownsell && productoAnterior">
                        <v-text-field label="Plan Downsell"
                            :value="productoAnterior.producto_lead + ' - ' + productoAnterior.nombre + ' - $' + productoAnterior.subsecuentePago"
                            outlined color="#b11f1f" readonly />
                    </v-col>
                    <v-col cols="12" md="6" lg="4" v-if="esDownsell && isViewMode && polizaSustituida">
                        <v-text-field label="Emisión Downsell" :value="polizaSustituida" outlined
                            color="#b11f1f" readonly append-icon="mdi-open-in-new"
                            @click:append="abrirEmision(polizaSustituida)" />
                    </v-col>

                    <v-col cols="12" md="12">
                        <v-textarea v-model="solicitudLocal.detalle" label="Detalle Solicitud" :readonly="isViewMode"
                            outlined color="#b11f1f"></v-textarea>
                    </v-col>
                </v-row>
                <v-row v-if="!isViewMode">
                    <v-col cols="12" sm="12" md="12" lg="12" xl="12" style="text-align: end">
                        <v-btn rounded dark class="common-botton" @click="checkBeforeSend" :disabled="loading">
                            <span style="padding-right: 11%">Siguiente</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </Card>

        <SolicitudActions :solicitud="solicitud" :modals="modals" @choice="handleChoice" @close="handleClose" />
    </div>
</template>

<script>
import { addTelefonoToListaNegra, validarExistenciaTelefonoEnListaNegra } from "@/services/listaNegraService.js";
import { getMotivosRetencion } from "@/services/motivosRetencionService";
import { getEmisionById } from "@/services/emision.service";
import { getProductoById, getProductoNivelInferior } from "@/components/productos/productosService";
import { mapState } from "vuex";
import Card from "@/components/commondComponents/Card.vue";
import SolicitudActions from "@/components/solicitudes/SolicitudActions.vue";

export default {
    components: {
        Card,
        SolicitudActions,
    },
    props: {
        mode: {
            type: String,
            default: "view",
        },
        showActions: {
            type: Boolean,
            default: false,
        },
        isCreatingNew: {
            type: Boolean,
            default: false,
        },
        solicitud: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            solicitudLocal: {},
            rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
            currentProduct: null,
            modals: {
                openEleccion: false,
            },
            polizaSustituida: null,
            agregarTelefonoListaNegra: false,
            isTelefonoInListaNegra: false,
            currentRol: JSON.parse(localStorage.getItem("roles"))[0].rol,
            loading: false,
            productoAnterior: null,
            statusItems: [
                { value: 1, text: "Nueva" },
                { value: 2, text: "En trámite" },
                { value: 3, text: "Cerrada" },
                { value: 4, text: "Folio Solicitado" },
                { value: 5, text: "Folio Obtenido" },
                { value: 6, text: "Folio Enviado" },
                { value: 7, text: "Atención Manual" },
                { value: 8, text: "Cancelada" },
                { value: 9, text: "Pendiente de autorización" },
                { value: 10, text: "Asignada" },
                { value: 11, text: "Pendiente de información" },
            ],
            motivosRetencion: []
        };
    },
    watch: {
        solicitud: {
            immediate: true,
            deep: true,
            handler(newVal) {
                const clone = JSON.parse(JSON.stringify(newVal || {}));
                clone.categoria = this.tipoServicio;
                clone.tipo = "Retención";
                this.solicitudLocal = clone;
            }
        },
    },
    computed: {
        ...mapState("permisos", ["permisos"]),

        isViewMode() {
            return this.mode === "view";
        },
        showActionsComp() {
            return this.showActions === true;
        },
        requiredRule() {
            return this.isViewMode
                ? []
                : [
                    (v) => {
                        if (!v) return "El campo es requerido";
                        if (typeof v === "object" && Object.keys(v).length === 0)
                            return "El campo es requerido";
                        return true;
                    },
                ];
        },
        botones() {
            return [
                {
                    label: "Agregar teléfono a lista negra",
                    icon: "mdi-close-circle",
                    show: !this.isTelefonoInListaNegra,
                    action: this.accionAgregarTelefonoListaNegra,
                },
            ];
        },
        tipoServicio() {
            return this.currentProduct?.tipo_producto
        },
        esDownsell() {
            return this.solicitudLocal.motivoRetencion?.trim().toLowerCase() === 'downsell';
        },
    },
    async mounted() {
        await this.loadProducto();
        await Promise.all([
            this.getMotivosRetencion(),
            this.checkIfTelefonoIsInListaNegra(),
            this.getProductoNivelInferior(),
            this.getEmisionById(),
        ]);
    },
    methods: {
        async loadProducto() {
            if (!this.solicitudLocal?.productoId) return;
            this.loading = true;
            try {
                const response = await getProductoById(this.solicitudLocal.productoId);
                this.currentProduct = response.data.producto;
                if (this.solicitudLocal) {
                    this.solicitudLocal.categoria = this.currentProduct?.tipo_producto;
                }
            } catch (error) {
                this.$toast.error(error.message);
            } finally {
                this.loading = false;
            }
        },
        async getEmisionById() {
            if (!this.solicitudLocal?.emisionId) return;
            try {
                const emision = await getEmisionById(this.solicitudLocal.emisionId);
                const sustituida = emision?.polizaSustituida ?? emision?.poliza_sustituida;
                this.polizaSustituida = /^\d+$/.test(String(sustituida ?? "").trim()) ? Number(sustituida) : null;
            } catch (error) {
                this.polizaSustituida = null;
            }
        },
        async getProductoNivelInferior() {
            if (!this.solicitudLocal?.productoId) return;
            this.loading = true;
            try {
                const response = await getProductoNivelInferior(this.solicitudLocal.productoId);
                if (response.status == 204) {
                    this.productoAnterior = null;
                    this.motivosRetencion = this.motivosRetencion.filter(m => m.motivoRetencion.trim().toLowerCase() !== 'downsell');
                    return;
                }
                this.productoAnterior = response.data;
            } catch (error) {
                this.productoAnterior = null;
                this.motivosRetencion = this.motivosRetencion.filter(m => m.motivoRetencion.trim().toLowerCase() !== 'downsell');
            } finally {
                this.loading = false;
            }
        },
        abrirEmision(id) {
            if (!id) return;
            const { href } = this.$router.resolve({ name: 'emision', params: { uuid: id } });
            window.open(href, '_blank');
        },
        async getMotivosRetencion() {
            try {
                const filters = {
                    status: 1,
                    tipo_producto: this.currentProduct.tipo_producto,
                    producto_aseguradora: this.currentProduct.producto_aseguradora || null,
                };
                const response = await getMotivosRetencion(filters);
                this.motivosRetencion = response.motivos_retencion;
            } catch (error) {
                console.error("Error al obtener los motivos de retención", error)
            }
        },
        async checkIfTelefonoIsInListaNegra() {
            if (!this.isViewMode || !this.solicitudLocal?.celular) return;
            try {
                const response = await validarExistenciaTelefonoEnListaNegra(this.solicitudLocal.celular);
                this.isTelefonoInListaNegra = response;
            } catch (error) {
                this.$toast.error("Error al validar la existencia del telefono en lista negra" + error.message + " contacta con un administrador para solucionar el problema.");
            }
        },
        accionAgregarTelefonoListaNegra() {
            this.resetEstadosAccion();
            this.modals.openEleccion = true;
            this.agregarTelefonoListaNegra = true;
        },

        resetEstadosAccion() {
            this.agregarTelefonoListaNegra = false;

            Object.keys(this.modals).forEach((key) => {
                this.modals[key] = false;
            });
        },
        closeAllActions() {
            this.modals = {
                openEleccion: false,
            };
            this.agregarTelefonoListaNegra = false;
        },
        async agregarToListaNegra() {
            this.loading = true;
            try {
                await addTelefonoToListaNegra({
                    telefono: this.solicitudLocal.celular,
                    origen: "Portal",
                    solicitudId: this.solicitudLocal.id,
                })
                this.isTelefonoInListaNegra = await validarExistenciaTelefonoEnListaNegra(this.solicitudLocal.celular);
                this.$toast.success("Telefono agregado a lista negra");
            } catch (error) {
                this.$toast.error(error.message);
            } finally {
                this.closeAllActions();
                this.loading = false;
            }
        },
        userChoice(val) {
            if (val && this.agregarTelefonoListaNegra) {
                return this.agregarToListaNegra();
            }
            this.closeAllActions();
            setTimeout(() => {
                this.$router.go(0);
            }, 2000);
        },
        async checkBeforeSend() {
            try {
                if (!this.$refs.firstStepForm.validate()) return;

                if (this.esDownsell && !this.productoAnterior) {
                    this.$toast.error("No hay plan downsell disponible para este producto");
                    return;
                }

                this.solicitudLocal.categoria = this.currentProduct?.tipo_producto;
                this.$emit("retencion", {
                    ...this.solicitudLocal,
                    productoDownsellId: this.esDownsell ? this.productoAnterior.id : null,
                });
            } catch (error) {
                this.$toast.error(error.message);
            }
        },

        handleChoice({ type, args }) {
            if (type === "eleccion") {
                const [val] = args;
                this.userChoice(val);
            }
        },
        handleClose(type) {
            this.modals[type] = false;
        },
    },
};
</script>

<style>
.botones-container {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-around;
    margin-bottom: 20px;
}

.stats-button {
    width: 300px;
    height: 40px !important;
    font-size: small;
    font-weight: bold;
    margin-top: 10px;
}
</style>
